// reviews.js

$(document).ready(function() {
  if ($('.review-txt-content > .slide').length >= 2) {
    $('.review-txt-content').cycle({});

    $('.review-txt-content').on('cycle-next cycle-prev', function(e, opts) {
      var top = $('#js_review-txt-content').offset().top;
      var reviewHeaderFullHeight = $('.l-header-full').height();
      // eslint-disable-next-line no-invalid-this
      $(this.blur());
      $('html, body')
        .animate({scrollTop: ((top - reviewHeaderFullHeight - 32))}, 500);
    });
  } else {
    $('.review-container').hide();
  }
});

//
// EOF
//
